// Layout.js
import React, {useEffect, useState} from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {  useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from "../services/ApiService";

const Layout = ({ children, hideHeader, hasPermission }) => {
    
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);

    const getNotifications = async () => {
        try {
            const response = await ApiService.request({
                method: "GET",
                url: "notifications?per_page=5",
            });
            const data = response.data;
            if (data.status) {
                setNotifications(data.data.notifications || []);
            } else {
                // Silently fail - notifications might not be available yet
                console.log('Notifications not available:', data.message);
            }
        } catch (error) {
            console.log('Error fetching notifications:', error);
        }
    };
        
    useEffect(() => {
        if (!hasPermission) {
            toast.error("You don't have permssion to access this!");
            navigate(-1); 
        }
        // getNotifications();
    }, [navigate, hasPermission]);

    return (
        <div className="d-flex flex-column flex-root app-root" id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {/* Conditionally render the header based on the hideHeader prop */}
            {!hideHeader && (
                 <div>
                    <Header notifications={notifications} getNotifications={getNotifications} setNotifications={setNotifications} />
                    <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                        <Sidebar notifications={notifications} />
                        {children} {/* Render child components here */}
                    </div>

                </div>
            )}
            {hideHeader && (
                <main>
                    {children} 
                </main>
            )}
           
            </div>
        </div>
    );
};

export default Layout;
